module.exports = __webpack_public_path__ + "static/4-edc529fd385a2c3ef8e322ece8da6114.jpg";